export type TCameraPermissionState = PermissionState | 'unsupported'

/**
 * Permissions API не умеет открывать настройки сайта.
 * denied — повторный системный запрос невозможен, только подсказка пользователю.
 */
export async function getCameraPermissionState(): Promise<TCameraPermissionState> {
  if (typeof navigator === 'undefined' || !navigator.permissions?.query) {
    return 'unsupported'
  }

  try {
    const status = await navigator.permissions.query({ name: 'camera' as PermissionName })

    return status.state
  }
  catch {
    /* Safari и часть Android-браузеров кидают TypeError на name: 'camera' */
    return 'unsupported'
  }
}
